<template>
	<li class="tree-item" v-if="isVisible">
		<div class="tree-item-content" :class="{ 'tree-item-disabled': isChildDisabled }">
			<img @click="toggleCollapse" v-if="modelValue[this.children]" class="chevron-icon" :class="{ 'rotate': isCollapsed }" src="./icons/chevron.svg" alt="">
			<Checkbox @click="checkboxClicked" :options="checkboxOptions" class="tree-item-checkbox" :modelValue="checkboxState" :disabled="modelValue[this.state]?.disabled" @update:modelValue="val => checkboxStateChanged(val)" /> <span class="tree-item-text" @click="toggleCollapse">{{ modelValue[this.text] }}</span>
		</div>
		<ul class="tree-list" :class="{ 'tree-collapse': isCollapsed }" v-if="modelValue[this.children]" ref="treeList">
			<TreeItem v-for="item in modelValue[this.children]" :parentDisabled="modelValue[this.state].disabled" :level="level + 1" :key="item[this.text]" :checkboxOptions="checkboxOptions" :fields="this.fields" :modelValue="item" @update:modelValue="val => treeItemDataChanged(val)" @change="val => $emit('change', val)" ref="treeChild" />
		</ul>
	</li>
</template>
<script>
	import Checkbox from './Checkbox.vue'
	import _ from 'lodash'
	export default {
		name: 'TreeItem',
		components: {
			Checkbox
		},
		props: {
			modelValue: {},
			fields: { type: [Object, Array] },
			checkboxOptions: {},
			level: { type: Number },
			isCompanyPeriodTree: { type: Boolean },
			parentDisabled: { type: Boolean, default: false },

		},
		emits: ['update:modelValue', 'change'],
		data() {
			return {
				isCollapsed: false,
			}
		},
		computed: {
			children() {
				if (_.isArray(this.fields))
					return this.fields[this.level] ? this.fields[this.level].children : this.fields[0].children
				return this.fields.children
			},
			text() {
				if (_.isArray(this.fields))
					return this.fields[this.level] ? this.fields[this.level].text : this.fields[0].text
				return this.fields.text
			},
			state() {
				if (_.isArray(this.fields))
					return this.fields[this.level] ? this.fields[this.level].state : this.fields[0].state
				return this.fields.state
			},
			lastLevelChildren() {
				let lastLevelItems = []

				const getComputeds = (item) => {
					if (item[this.children]?.length) {
						item[this.children].forEach(child => getComputeds(child))
					} else {
						lastLevelItems.push(item)
					}
				}

				getComputeds(this.modelValue)

				return lastLevelItems
			},
			isVisible() {
				if (this.modelValue[this.state].visible !== false) {
					if (this.modelValue[this.children]) {
						const someVisible = this.lastLevelChildren.some(child => child[this.state].visible !== false)
						return someVisible
					}
					return true
				}
				return false
			},
			halfChecked() {
				if (this.isCompanyPeriodTree) {
					return false
				}
				if (this.modelValue[this.children]) {
					return this.lastLevelChildren.some(child => child[this.state].isChecked)
				}
				return false
			},
			checked() {
				if (this.isCompanyPeriodTree) {
					return this.modelValue[this.state].isChecked
				}
				if (this.modelValue[this.children]) {
					return this.lastLevelChildren.every(child => child[this.state].isChecked)
				}
				return this.modelValue[this.state].isChecked
			},
			checkboxState() {
				if (this.checked) {
					return 'checked'
				}
				else if (this.checked === false) {
					if (this.halfChecked) {
						return 'halfChecked'
					}
					else {
						return 'unchecked'
					}
				}
			},
			isChildDisabled() {
				return this.modelValue[this.state]?.disabled || this.parentDisabled
			},
		},
		methods: {
			getLastLevelChildsFromThisSection() {
				let lastLevelItems = []

				const getComputeds = (item) => {
					if (item[this.children]?.length) {
						item[this.children].forEach(child => getComputeds(child))
					} else {
						lastLevelItems.push(item)
					}
				}

				getComputeds(this.modelValue)

				return lastLevelItems
			},
			checkboxClicked() {
				this.$emit('change', this.getLastLevelChildsFromThisSection())
				if (this.isCompanyPeriodTree) {
					this.$emit('change', this.modelValue)
				}
			},
			countDifferentStates(item, state) {
				let count = 0
				if (item[this.state].isChecked !== state) {
					count++
				}

				if (item[this.children]) {
					for (let i = 0; i < item[this.children].length; i++) {
						count += this.countDifferentStates(item[this.children][i], state)
					}
				}

				return count
			},
			treeItemDataChanged(val) {
				if (this.isCompanyPeriodTree) {
					this.emit(val)
					return
				}
				if (this.modelValue[this.children] && this.modelValue[this.children].length > 0) {
					let dataState = true

					for (let i = 0; i < this.modelValue[this.children].length; i++) {
						if (this.modelValue[this.children][i][this.state].isChecked === false) {
							dataState = false
						}
					}
					if (val[this.state].isChecked === false) {
						dataState = false
					}
					let clonedData = this.modelValue
					clonedData[this.state].isChecked = dataState
					this.emit(clonedData)
				}
				this.emit(val)

			},

			checkboxStateChanged(val) {

				let clonedData = this.modelValue

				if (this.isCompanyPeriodTree) {
					if (clonedData[this.children]?.length) {
						this.setChildrenDisabledState(clonedData[this.children], !val)
					}
					clonedData[this.state].isChecked = val
					this.emit(clonedData)
					return
				}

				const rec = (items, state) => {
					items.forEach(child => {
						child[this.state].isChecked = state
						if (child[this.children]) {
							child[this.children] = rec(child[this.children], state)
						}
					})
					return items
				}

				if (clonedData[this.children]) {
					clonedData[this.children] = rec(clonedData[this.children], val)
				}

				clonedData[this.state].isChecked = val

				this.emit(clonedData)
			},
			emit(data) {
				this.$emit('update:modelValue', data)
			},
			setChildrenDisabledState(children, disableChildren) {
				if (!children || !children.length) return

				children.forEach(child => {
					if (!child[this.state]) {
						child[this.state] = { isChecked: false }
					}

					child[this.state].disabled = disableChildren

					if (disableChildren) {
						child[this.state].isChecked = false
						if (child[this.children]?.length) {
							this.setChildrenDisabledState(child[this.children], true)
						}
					}
				})
			},
			toggleCollapse() {
				// if (this.modelValue[this.children])
				// 	this.$refs.treeList.classList.toggle('collapse')
				this.isCollapsed = !this.isCollapsed
			},
		}
	}
</script>

<style scoped>
	.tree-item {
		white-space: nowrap;
		display: flex;
		flex-direction: column;
		position: relative;
		box-sizing: border-box;
		padding: 8px 0px;
	}

	.tree-item-content {
		display: flex;
		align-items: center;
		cursor: pointer;
		width: 100%;
		box-sizing: border-box;
		user-select: none;
		position: relative;
		padding-right: 20px;
	}

	.tree-item-text {
		flex: 1;
		height: 100%;
		display: block;
		overflow: auto;
	}

	.tree-item-content:hover {
		background-color: #f6f8fb;
	}

	.tree-item-disabled {
		color: #999999;
		cursor: not-allowed;
	}

	.tree-list {
		display: none;
		padding: 0px 30px;
		animation: fadeInRight 0.4s ease-in-out;
	}

	.tree-collapse {
		display: block;
	}

	.chevron-icon {
		height: 25px;
		transition: transform 0.4s;
		position: absolute;
		right: 0px;
	}

	.chevron-icon.rotate {
		transform: rotate(-90deg);
	}

	@keyframes fadeInRight {
		from {
			opacity: 0;
			transform: translateX(20px);
		}

		to {
			opacity: 1;
		}
	}
</style>